// @core/api/endpoints/userprofile/create_userprofile.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateUserprofileRequest,
  UserprofileResponse,
} from '../../../types/userprofile';

const BASE_PATH = '/userprofile';

/**
 * Create a new user profile
 * Creates a new user profile with the specified details. The caller becomes the owner of the profile and can manage its settings and visibility.
 */
export async function CreateUserprofile(
  data: CreateUserprofileRequest,
  options?: RequestOptions
): Promise<UserprofileResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/`;
  const requestOptions = options;
  return client.post<UserprofileResponse>(requestPath, data, requestOptions);
}
